import { useQuery } from "react-query";
import { useAccessToken } from "hooks/useAccessToken";
import { QUERY_STALE_TIME } from "utils/constants";
import queryFn from "ApiLayer/Reports/Baseline/queryBuildingBarChartAndMapByProperty";

export const useBuildingBarChartAndMapByProperty = (filtersetUid: string | null) => {
    const accessToken = useAccessToken();

    return useQuery({
        queryKey: ["buildingBarChartAndMapByProperty", filtersetUid],
        queryFn: async () => {
            if (filtersetUid === null) {
                return [];
            }
            return queryFn(accessToken, { reportFiltersetUid: filtersetUid });
        },
        staleTime: QUERY_STALE_TIME,
        enabled: !!filtersetUid,
    });
};
